import { Injectable } from '@angular/core';
import { CustomerPasswordResetDTO, CustomerPasswordResetRequestValidateDTO, CustomerPasswordResetRequestDTO } from '@dto';
import { Observable } from 'rxjs';

;
import { map } from 'rxjs/operators';
import { CustomerClientService } from '../../client/customer-client.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordRecoveryService
{

  constructor(private customerClientService: CustomerClientService)
  {
  }

  public recover(model: CustomerPasswordResetRequestDTO): Observable<boolean>
  {
    return this.customerClientService.recoverPassword(model);
  }

  public checkToken(passwordToken: string): Observable<boolean>
  {
    return this.customerClientService.checkPasswordRecoveryToken({
      passwordResetRequestToken: passwordToken
    }).pipe(map(() => true));
  }

  public createNewPassword(token, password): Observable<boolean>
  {
    return this.customerClientService.createPasswordRecoveryNewPassword({
      passwordResetRequestToken: token,
      newPassword: password
    }).pipe(map(() => true));
  }

}
